// The four parent sections as one Tabs navigator (FR-005, FR-006; plan "Chrome"). Mobile chrome
// shows the bottom tab bar; desktop chrome shows none (the header has the links). One navigator for
// both, so crossing the 1024 px breakpoint never remounts the screens.
import { Tabs } from "expo-router";

import { MobileTabBar } from "@/shell/chrome/MobileTabBar";
import { parentSections } from "@/shell/chrome/sections";
import { useChromeKind } from "@/shell/chrome/useChromeKind";

export default function ParentTabsLayout() {
  const chrome = useChromeKind();
  return (
    <Tabs
      screenOptions={{ headerShown: false }}
      tabBar={(props) =>
        chrome === "mobile" ? <MobileTabBar {...props} /> : null
      }
    >
      {parentSections.map((s) => (
        <Tabs.Screen key={s.name} name={s.name} options={{ title: s.label }} />
      ))}
    </Tabs>
  );
}

// A screen that throws shows the themed fallback (FR-041; US6-2).
export { ErrorFallback as ErrorBoundary } from "@/shell/ErrorFallback";
